import NoDataFound from './noDataFound'
export default NoDataFound
